import type { IconName } from "./icons";
import { AVATAR_ICONS } from "../../composables/Api/Type/UserGroup/avatarIconIdentifier";

/**
 * The API stores the icon of a user group, report topic, property route or view as a Font Awesome name
 * (`avatarIconIdentifier`, e.g. `shield-alt`). The API keeps those names; this maps each name it can hold to the icon
 * the app draws: the avatar icons of `AvatarIconIdentifierEnum` and the icons only views can choose.
 */
const STORED_ICON_NAMES: Readonly<Record<string, IconName>> = {
  ...AVATAR_ICONS,
  "archive": "archive",
  "arrow-right-arrow-left": "arrow-right-left",
  "calendar-alt": "calendar-days",
  "calendar-day": "calendar-1",
  "check": "check",
  "check-double": "check-check",
  "clone": "copy",
  "list": "list",
  "repeat": "repeat",
  "route": "route",
  "tasks": "list-check",
  "thumbtack": "pin",
  "user": "user",
  "user-friends": "user-group",
  "user-slash": "user-x",
  "users-class": "presentation",
};

/** The icon to draw for a stored icon name, or `null` when the value is empty or not a known name. */
export function storedIcon(identifier: string | null | undefined): IconName | null {
  if (identifier == null || !Object.hasOwn(STORED_ICON_NAMES, identifier)) {
    return null;
  }
  return STORED_ICON_NAMES[identifier];
}

/** The icon to draw for a stored icon name, or `fallback` when the value is empty or not a known name. */
export function iconFromStoredName(identifier: string | null | undefined, fallback: IconName): IconName {
  return storedIcon(identifier) ?? fallback;
}
